module.exports = __webpack_public_path__ + "static/media/medical-coverage.c9edd37d.svg";